module.exports = __webpack_public_path__ + "static/the-neverending-story-99188aea5868f3b4b386030829c53efa.jpg";